var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box flex flex-center align-items-cnenter",class:_vm.FootType === 1 ? 'bg-560a0f' : 'bg-B9202F'},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-box flex flex-center align-items-cnenter"},[_c('div',[_vm._v("山西省教育厅")])])
}]

export { render, staticRenderFns }